import { useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "../../../../parts/inputs/select";
import Modal from "../../../../parts/modal-new";
import ModalFooter from "../../../../parts/modals/ModalFooter";
import { getIntervalString } from "../../../../utils/stripe-helpers";

export const PlanTrial = ({ plan = {} }) => {
  const { t } = useTranslation("coaching-portal");
  const { id, metadata, recurring } = plan;
  const [trialDays, setTrialDays] = useState(metadata?.trial_days);

  const [hasFreeTrial, setHasFreeTrial] = useState(!!trialDays);
  const maxDays = recurring?.interval === "week" ? 7 : 30;
  const intervalString = getIntervalString(recurring);

  return (
    <Modal
      className="plan-modal trial"
      toClear={["plan", "type"]}
      title={t("planManager.planTrial.editPlanTitle", {
        interval: intervalString,
      })}
    >
      <form
        className="body"
        action="/actions/plan-manager/add-trial"
        method="POST"
        data-noreset
        id="add-trial"
      >
        <input type="hidden" name="id" value={id} />
        <div className="modal-body">
          <div className="row">
            <div className="group">
              <label className="label" htmlFor="switch">
                {t("planManager.planTrial.addFreeTrialOptional")}
              </label>

              <input
                type="checkbox"
                id="switch"
                role="switch"
                name="hasFreeTrial"
                checked={hasFreeTrial}
                onChange={() => setHasFreeTrial((state) => !state)}
              />
            </div>
          </div>

          <div className="row">
            <div className="group">
              <Select
                title={t("planManager.planTrial.freeTrialDays")}
                name="trial_days"
                id="trial_days"
                value={trialDays || 1}
                disabled={!hasFreeTrial}
                onChange={(val) => setTrialDays(val)}
                options={Array.from({ length: maxDays }, (_v, i) => {
                  return {
                    text: i + 1,
                    value: i + 1,
                  };
                })}
                overlay
              />
            </div>
          </div>
        </div>
      </form>
      <ModalFooter
        isSubmitButton
        showAltButton={false}
        onClickButton={() => {}}
        classNameButton="button save"
        formId="add-trial"
      />
    </Modal>
  );
};
